/**
 * Reality Check model
 */

define(function(require) {
    var BaseModel = require('common/base.model');
    var server = require('server');

    return BaseModel.extend({
        subscribe: function() {
            this.on('change:realityCheckEnabled', this.realityCheckHandler);
        },

        sync: function(method) {
            if (method === 'read') {
                this.getConfig();
            }
        },

        realityCheckHandler: function(model, isEnabled) {
            isEnabled && this.getPlayerReality();
        },

        getPlayerReality: function() {
            server.send({
                ID: 89913,
                description: 'Get Player Reality Check',
                responses: [89914]
            }).done(({ data: { isEnabled, timePeriod } }) => this.set({ isEnabled, timePeriod }));
        },

        getConfig: function() {
            server.send({
                ID: 32942,
                description: 'GetRgConfigurationRequest',
                type: [1],
                responses: [32943, 32944]
            }).done(({ data: { realityCheckConfigurationItems } }) => this.set(realityCheckConfigurationItems[0]));
        },

        setRealityCheck: function(timePeriod) {
            return server.send({
                timePeriod,
                ID: 89915,
                description: 'Set Player Reality Check',
                isEnabled: Boolean(timePeriod),
                correlationId: 'set-reality-check',
                responses: [89916, 89406, 89900]
            }).done(() => this.set({ timePeriod }));
        }
    });
});

